import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'


const SerieNumeroFormGroup = ({
  fIsSubmitting,
  handleBlur,
  vSerie,
  vTipoDocumento,
  vTipoOperacion,
  setFieldValue,
  iTouched,
  iError
}) => {

  return (
    <>
      <Form.Group>
        <Form.Label text='SERIE' htmlFor='input-serieDocumento' md={4} alignRightAt='md' />
        <Col md={8}>
          <Field name='serieDocumento'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-serieDocumento'
                disabled={fIsSubmitting}
                isInvalid={iTouched && iError}
                className='zr-text-upper'
                maxLength={4}
              />
            )}
          </Field>
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
